<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'SundryItemsHome'
  }
</script>

<style lang="scss">

</style>
